import { IBreadCrumbItem } from "Data/interfaces/ListagemArquivos/IListFilesResponse";
import { NotificationActionEnum } from "Data/enums/Notification";

import { INotificationsMapAux } from "Data/interfaces/Notification/INotificationsMapAux";
import { IconName } from "Components/UI";
import { TypeIconsEnum } from "Data/interfaces/Activities/IDragAndDropDataFormat";
import { disciplineIcons, resolveCustomDisciplineIcon } from "Utils/Icons";

// Lives here (instead of Pages/Disciplinas, its historical home) so this
// module never imports from a Pages/* file — that previously created a
// circular import chain (Pages/Disciplinas -> ... -> Utils/ObraUtils ->
// Pages/Disciplinas) that intermittently crashed with a TDZ ReferenceError.
export enum DisciplineIconsEnum {
  'Arquitetura' = 'disciplinaArquitetura',
  'Estrutura' = 'disciplinaEstrutura',
  'Instalações Eletricas e Sistemas' = 'disciplinaEletrica',
  'Instalações Hidrossanitarias' = 'disciplinaHidrossanitaria',
  'Instalações Mecânicas' = 'disciplinaMecanica',
  'Fundações' = 'disciplinaFundacao',
  'Ar Condicionado' = 'disciplinaAr',
  'Incêndio' = 'disciplinaIncendio',
  'Engineer' = 'menuContexto',
  'Arquivos obsoletos' = 'obsoleteArchive',
}

export const GetDisciplineApiFolderIdFromBreadCrumb = (breadCrumbItem: IBreadCrumbItem) => {
    let disciplineApiFolderId: string;
    let breadCrumbAux: IBreadCrumbItem | undefined = breadCrumbItem;

    do {
        disciplineApiFolderId = breadCrumbAux.Identifier;
        breadCrumbAux = breadCrumbAux.PreviousItem;
    } while (breadCrumbAux && breadCrumbAux != null && breadCrumbAux?.Identifier != null);

    return disciplineApiFolderId;
}

export const mapNotification = (notifications: INotificationsMapAux[], uniqueId?: boolean) => {
  const allowedActions = [NotificationActionEnum.ArquivoMovido,
     NotificationActionEnum.NovoArquivo, NotificationActionEnum.NovaVersaoArquivo];
  
  const items = notifications.map((item: INotificationsMapAux) => {
    if (allowedActions.includes(item.Action) && !item.hasRead) {
      return uniqueId ? item.ItemId : item.ItemsAux;
    }

    return []
  }).flat();

  

  return items;
}

export const getDisciplineIcon = (name: string): IconName => {
  if ((DisciplineIconsEnum as any)[name]) {
    return (DisciplineIconsEnum as any)[name];
  }
  return 'menuContexto';
}

export interface IDisciplineIconSource {
  CustomIcon?: string | null;
  Discipline?: {
    IsCustom?: boolean;
    Icon?: string;
  } | null;
}

/**
 * Resolves the icon to render for a discipline, honoring a custom-picked
 * icon on custom disciplines instead of relying on name-based lookups
 * (which never match freely-typed custom discipline names).
 */
export const getDisciplineDisplayIcon = (discipline?: IDisciplineIconSource | null): IconName => {
  if (!discipline) return 'menuContexto';

  if (discipline.Discipline?.IsCustom) {
    return resolveCustomDisciplineIcon(discipline.CustomIcon);
  }

  return disciplineIcons.get(discipline.Discipline?.Icon || '') || 'menuContexto';
}

export const getTypeIcon = (name: string): IconName => {
  if ((TypeIconsEnum as any)[name]) {
    return (TypeIconsEnum as any)[name];
  }
  return 'activities'; 
}

export const obraAvatarImagesAccepts = [
  'image/apng',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/gif',
];

export const maxObraAvatarUploadSize = 1024 * 1024 * 128;
